export default __webpack_public_path__ + "static/media/eye-purple.c1a4319f.svg";